<template>
  <component :is="component.componentName" />
</template>

<script>
import prospective from "./tabs/ProspectiveStudentsTabContent";
import aplication from "./tabs/AplicationTabComponent";
import accepted from "./tabs/AcceptedTabContentCompnent";
import onSite from "./tabs/OnSiteTabContentComponent";
import withdrawn from "./tabs/WithdrawnTabComponent";
import all from "./tabs/AllTabComponent";
import alumni from "./tabs/AlumniTabContentCompnent";
import { mapGetters } from "vuex";

export default {
  components: {
    prospective: prospective,
    application: aplication,
    accepted: accepted,
    onsite: onSite,
    withdrawn: withdrawn,
    all: all,
    alumni: alumni
  },
  computed: {
    ...mapGetters({
      component: "currentTabComponent"
    })
  }
};
</script>
